const PREFIX = 'NOTIFICATION_'

export const NOTIFICATION_SUCCESS = `${PREFIX}SUCCESS`

export const NOTIFICATION_ERROR = `${PREFIX}ERROR`

export const NOTIFICATION_RESET = `${PREFIX}RESET`

export const NOTIFICATION_LOADING = `${PREFIX}LOADING`



// WEBPACK FOOTER //
// app/javascript/components/actions/notification/constants.js